import { render, staticRenderFns } from "./PhoneNumber.vue?vue&type=template&id=c04e5e40&"
import script from "./PhoneNumber.vue?vue&type=script&lang=ts&"
export * from "./PhoneNumber.vue?vue&type=script&lang=ts&"
import style0 from "./PhoneNumber.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports